import { Tab } from '@headlessui/react';
import clsx from 'clsx';
import { ReactNode } from 'react';

interface TabItem {
  label: string;
  content: ReactNode;
}

interface TabsProps {
  tabs: TabItem[];
}

export const Tabs = ({ tabs }: TabsProps) => {
  return (
    <Tab.Group>
      <Tab.List className="flex gap-1 border-b border-gray-300">
        {tabs.map((tab, idx) => (
          <Tab
            key={idx}
            className={({ selected }) =>
              clsx(
                'px-4 py-2 text-s font-bold transition-colors focus:outline-none',
                selected
                  ? 'border-b-2 border-gold text-gold'
                  : 'text-gray-600 hover:text-gold'
              )
            }
          >
            {tab.label}
          </Tab>
        ))}
      </Tab.List>
      <Tab.Panels className="mt-4">
        {tabs.map((tab, idx) => (
          <Tab.Panel key={idx}>{tab.content}</Tab.Panel>
        ))}
      </Tab.Panels>
    </Tab.Group>
  );
};
